import { createFormHook, createFormHookContexts } from '@tanstack/react-form';
import { InputField, AdvisoryComboboxField } from './fields';

export const { fieldContext, formContext, useFieldContext } =
  createFormHookContexts();

const { useAppForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    InputField,
    AdvisoryComboboxField,
  },
  formComponents: {},
});

export { useAppForm };
